export var AdminDepositStatusType;
(function (AdminDepositStatusType) {
    AdminDepositStatusType[AdminDepositStatusType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AdminDepositStatusType[AdminDepositStatusType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    AdminDepositStatusType[AdminDepositStatusType["CANCEL"] = 3] = "CANCEL";
})(AdminDepositStatusType || (AdminDepositStatusType = {}));
//# sourceMappingURL=AdminDepositStatusType.js.map